import Vue from 'vue'
import Layout from '@/layout'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
/**
 *
 * meta配置
 * title 面包屑用的标题
 * showNotice true为显示notice,不写则默认不显示
 * showBread true为显示bread,不写则默认不显示
 * showTabbar true为显示Tabbar,不写则默认不显示
 *
 */

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        component: Home,
        name: 'Home',
        meta: {
          title: '首页',
          navName: 'Home',
          showBread: false,
          showFooter: true,
          keepAlive: true,
        },
      },
      {
        path: 'Artbuying',
        component: () => import('@/views/Artbuying/Artbuying'),
        name: 'Artbuying',
        meta: {
          title: '艺术品购买',
          showBread: false,
          navName: 'Artbuying',
          showFooter: true,
          keepAlive: true,
        },
        children: [
          {
            path: '/ArtbuyingDetail',
            name: 'ArtbuyingDetail',
            component: () => import('@/views/Artbuying/ArtbuyingDetail'),
            meta: {
              title: '艺术品购买详情',
              navName: 'ArtbuyingDetail',
              showBread: false,
              keepAlive: false,
            },
          },
        ],
      },
      {
        path: 'NewsList',
        component: () => import('@/views/News/index'),
        name: 'NewsList',
        meta: {
          title: '全部资讯',
          showBread: false,
          navName: 'NewsList',
          showFooter: true,
          keepAlive: false,
        },
        children: [
          {
            path: '/NewsDetail',
            component: () => import('@/views/News/NewsDetail'),
            name: 'NewsDetail',
            meta: {
              title: '资讯详情',
              showBread: false,
              keepAlive: false,
            },
          },
        ]
      },
      // {
      //   path: 'NewsDetail',
      //   component: () => import('@/views/News/NewsDetail'),
      //   name: 'NewsDetail',
      //   meta: {
      //     title: '资讯详情',
      //     showBread: false,
      //     navName: 'NewsDetail',
      //     showFooter: true,
      //   },
      // },
      {
        path: 'ArtistList',
        component: () => import('@/views/Artist/index'),
        name: 'ArtistList',
        meta: {
          title: '全部艺术家',
          showBread: false,
          navName: 'ArtistList',
          showFooter: true,
          keepAlive: false,
        },
        children: [
          {
            path: '/ArtistDetail',
            component: () => import('@/views/Artist/ArtistDetail'),
            name: 'ArtistDetail',
            meta: {
              title: '艺术家详情',
              showBread: false,
              navName: 'ArtistDetail',
              showFooter: true,
              keepAlive: false,
            },
          },
        ]
      },
      // {
      //   path: 'ArtistDetail',
      //   component: () => import('@/views/Artist/ArtistDetail'),
      //   name: 'ArtistDetail',
      //   meta: {
      //     title: '艺术家详情',
      //     showBread: false,
      //     navName: 'ArtistDetail',
      //     showFooter: true,
      //     keepAlive: false,
      //   },
      // },
      {
        path: 'Search',
        component: () => import('@/views/Search/index'),
        name: 'Search',
        meta: {
          title: '搜索',
          showBread: false,
          navName: 'Search',
          showFooter: true,
          keepAlive: true,
        },
      },
      {
        path: 'Example',
        component: () => import('@/views/Example/index'),
        name: 'Example',
        meta: {
          title: '艺术品定制',
          showBread: false,
          navName: 'Example',
          showFooter: true,
          keepAlive: true,
        },
      },
      {
        path: 'ArtworkPeriphery',
        component: () => import('@/views/ArtworkPeriphery/ArtworkPeriphery'),
        name: 'ArtworkPeriphery',
        meta: {
          title: '艺术品周边',
          showBread: false,
          navName: 'ArtworkPeriphery',
          showFooter: true,
          keepAlive: true,
        },
        children: [
          {
            path: '/ArtworkPeripheryDetail',
            name: 'ArtworkPeripheryDetail',
            component: () => import('@/views/ArtworkPeripheryDetail/ArtworkPeripheryDetail'),
            meta: {
              title: '艺术品周边详情',
              showBread: false,
              keepAlive: false,
            },
          },
        ],
      },
      {
        path: 'AboutUs',
        component: () => import('@/views/AboutUs/AboutUs'),
        name: 'AboutUs',
        meta: {
          title: '关于我们',
          showBread: false,
          navName: 'AboutUs',
          showFooter: true,
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  }
]
const router = new VueRouter({
  routes,
})

export default router
